import React from 'react'
import Badge from '../../../../UniformComponents/Badge'

const Applied = ({ show }) => (
    !show
        ? null
        : (
            <Badge
                label="Applied"
                icon="fa-solid fa-check"
                cssClass="applied"
            />
        )
)

export default Applied
